import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  containerSubmitPassword: {
    width: '50%'
  },
  titleSection: {
    color: theme.palette.primary.contrastText,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    letterSpacing: '0.000125rem'
  },
  contentInstruction: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f8f2d5',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  IconInstruction: {
    color: theme.palette.warning.main,
    marginRight: theme.spacing(1)
  },
  contentInputSubmitPassword: {
    marginTop: theme.spacing(2)
  },
  inputPasswordBox: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(3)
  },
  inputLabel: {
    fontWeight: 700,
    color: theme.palette.primary.contrastText
  },
  input: {
    borderRadius: theme.spacing(3),
    marginTop: theme.spacing(1),
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(3)
    }
  },
  errorsBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    '& .MuiTypography-root': {
      marginLeft: theme.spacing(0.5)
    }
  },
  submitButton: {
    flexWrap: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '45px',
    minWidth: '180px',
    borderRadius: '30px',
    background: theme.palette.primary.contrastText,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(5),
    '&:hover': {
      background: theme.palette.primary.dark
    },
    '& .MuiButton-label': {
      flexWrap: 'nowrap'
    }
  },
  needHelp: {
    color: theme.palette.grey[300],
    marginTop: theme.spacing(3)
  }
}))
